import React, { useState, useRef } from "react";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Card } from "primereact/card";
import { ToggleButton } from 'primereact/togglebutton';
import BraintreeSubscription from './BraintreeSubscription'
import axios from "axios";

const Subscription = ({ initialData, refresh }) => {
    const [formData, setFormData] = useState(initialData);
    const [braintreeStatus, setBraintreeStatus] = useState(null);
    const [errors, setErrors] = useState({});
    const [pin, setPin] = useState(null);
    const [braintreeRefreshTrigger, setBraintreeRefreshTrigger] = useState(0);
    const toast = useRef(null);
    const prescriptionOptions = Array.from({ length: 13 }, (_, i) => ({
        label: i.toString(),
        value: i
    }));

    const setBraintreeStatus_ = (status) => {
        setBraintreeStatus(status)
    };


    const handleSubmit = (e) => {
        e.preventDefault();


        const url = "/api/ha/SaveSubscriptionChanges";

        const params = {
            actionType: 'UpdateSubscription',
            caseID: initialData.id,
            member_id: formData.member_id,
            subscription_id: formData.subscription_id,
            active: formData.active,
            remaining_prescription: formData.remaining_prescription
        };

        axios
            .post(url, params)
            .then((response) => {
                if (response.data.status === 'OK') {
                    refresh();
                    toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'Saved successfully!', life: 6000 });
                   }
                else {
                    alert(response.data.errMsg);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Error:" + error);
            });

    };

    const cancelBraintreeSubs = (pinValue) => {
        if (!pinValue) {
            alert('Pin is required.');
            return false;
        }
        var subscriptionId = formData.subscription_id;
        const url = `api/braintree/subscription/cancel`;

        const params = {

            "subscriptionId": subscriptionId,
            "pin": pinValue
        }

        var endpoint = location.origin + '/' + url;
        axios.post(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.statusText === "OK") {
                    toast.current.show({ severity: 'info', summary: 'Confirmed', detail: response.data, life: 6000 });
                    // Trigger a refresh of the BraintreeSubscription component
                    setBraintreeRefreshTrigger(prev => prev + 1);
                }

            })
            .catch(function (response) {
                //handle error
                toast.current.show({ severity: 'error', summary: 'Failed', detail: response.response.data, life: 6000 });
                
            });
    }
  

    
    const showCancelPopup = (event) => {
        confirmDialog({
            target: event.currentTarget,
            group: 'templating',
            header: 'Confirmation',
            message: (
                <div className="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
                    <i className="pi pi-exclamation-circle text-6xl text-primary-500"></i>
                    <span>Enter your PIN to confirm:</span>
                    <input
                        type="password"
                        className="p-inputtext p-component"
                        id="pinInput"
                        placeholder="Enter PIN"
                    />
                </div>
            ),
            acceptIcon: 'pi pi-check',
            rejectIcon: 'pi pi-times',
            rejectClass: 'p-button-sm',
            acceptClass: 'p-button-outlined p-button-sm',
            accept: () => {
                const pinValue = document.getElementById('pinInput').value;
                if (!pinValue) {
                    alert('Pin is required.');
                    return false;
                }
                cancelBraintreeSubs(pinValue);
            },
            reject: () => console.log('closed')
        });
    }

    return (
        <div className="mt-4">
            <Toast ref={toast} />
            <ConfirmDialog group="templating" />
            <Card>
               
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="d-flex flex-row mb-3">
                        
                        <div className="p-1  mr-3">
                                <label className="">Member ID</label>
                                <div className="">{formData.member_id}</div>
                            </div>
                            <div className="p-1  mr-3">
                                <label className="">Subscription ID</label>
                                <div className="">{formData.subscription_id}</div>
                            </div>
                            <div className="p-1  mr-3">
                                <label className="">Plan ID</label>
                                <div className="">{formData.plan_id}</div>
                            </div>
                            <div className="p-1  mr-4">
                                <label className="">Delivery Type</label>
                                <div className="">{formData.deliveryType}</div>
                            </div>
                            <div className="p-1">
                                <label className="">Subscription Type</label>
                                <div className="">{formData.SubsType}</div>
                            </div>
                        </div>
                        <div>
                            {braintreeStatus !== formData.active ?
                                <div className="alert alert-danger" role="alert">
                                    Braintree is not sync with HA
                                </div>
                               
                                : ''}
                        </div>
                        <div>
                            
                            <BraintreeSubscription 
                                SubsID={formData.subscription_id} 
                                setBraintreeStatus={setBraintreeStatus_}
                                key={braintreeRefreshTrigger}  
                            />
                        </div>
                        <div className="d-flex flex-row mb-3 mt-2">
                            <div className="p-1 mr-2">
                                <label className="form-label">Status</label>
                                <div>
                                    <ToggleButton
                                        checked={formData.active}
                                        onChange={(e) => setFormData({ ...formData, active: e.value })}
                                        onLabel="Active Member"
                                        offLabel="Inactive Member"
                                        onIcon="pi pi-check" 
                                        offIcon="pi pi-times"
                                        className="w-100"
                                    />
                                </div>
                            </div>
                            <div className="p-1 mr-2">
                                <label className="form-label">Remaining Prescriptions</label>
                                <Dropdown
                                    value={formData.remaining_prescription}
                                    options={prescriptionOptions}
                                    onChange={(e) => setFormData({ ...formData, remaining_prescription: e.value })}
                                    placeholder="Select remaining prescriptions"
                                    className="w-100" 
                                />
                            </div>
                            <div className="p-1 mr-2 mt-3">
                                <Button type="submit" label="Save Changes" className="p-button-primary mt-3" />
                                <Button type="button" label="Cancel Braintree Subcription" className="p-button-primary mt-3 ml-3" onClick={showCancelPopup } />
                            </div>
                           
                        </div>
                       
                    </div>
                </form>
            </Card>
        </div>
    );
};

export default Subscription;
